import { Box, Skeleton } from "@mui/material";
import { style } from "../hero.style";

export const TableSkeleton = () => (
  <Box sx={style.skeleton}>
    <Skeleton height={20} width="calc(100% - 40px)" variant="rounded" sx={style.skeleton.heading} />
    {Array.from(Array(10).keys()).map((el) => <Skeleton variant="rounded" key={el} sx={style.skeleton.item} width="100%" />)}
  </Box>
);
